import { Box, Card, CardContent, CardHeader, Link, List, ListItem, Table, TableBody, TableCell, TableHead, TableRow, Tab, Tabs, Typography } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import TabPanel from '../TabPanel';

const InfoPage = () => {
	const [activeTab, setActiveTab] = useState(() => {
		// Load saved tab from localStorage on initial render
		const savedTab = localStorage.getItem('InfoPage_activeTab');
		return savedTab ? parseInt(savedTab, 10) : 0;
	});
	const contentRef = useRef<HTMLDivElement>(null);

	// Save tab to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem('InfoPage_activeTab', activeTab.toString());
	}, [activeTab]);

	

	// Restore scroll position when tab becomes active
	useEffect(() => {
		const savedPositions = JSON.parse(localStorage.getItem('InfoPage_scrollPositions') || '{}');
		const savedPosition = savedPositions[activeTab];
		
		if (savedPosition !== undefined) {
			// Use setTimeout to ensure DOM is ready
			setTimeout(() => {
				window.scrollTo({
					top: savedPosition,
					behavior: 'auto'
				});
			}, 100);
		}
	}, [activeTab]);

	const tabs = [
		'כללי - GroupHug',
		'פעם ראשונה אצלנו? הגדרת הפרופיל בפעם הראשונה',
		'צד המנוי',
		'הפרופיל האישי',
		'זמני הפעילות',
		'סנכרון יומן',
		'יומן פגישות ומפגשים פרטניים',
		'הרצאות וסדנאות',
		'תשלומים',
		'לינקים ודרכי קשר',
	];

	return (
		<Box dir='rtl' sx={{ width: '100%', display: 'flex', gap: 2,marginTop:3 }}>
			{/* Tabs Column on Right */}
			<Box
				sx={{
					backgroundColor: 'grey.50',
					borderRadius: 1.5,
					p: 0.5,
					boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
					minWidth: 250,
					maxWidth: 300,
					height: 'fit-content',
					position: 'sticky',
					top: 20,
				}}
			>
				<Tabs
					orientation='vertical'
					variant='scrollable'
					scrollButtons={false}
					sx={{
						direction: 'rtl',
						'& .MuiTabs-scrollButtons': {
							display: 'none',
						},
						'& .MuiTab-root': {
							fontWeight: 600,
							fontSize: '0.75rem',
							minHeight: 36,
							textTransform: 'none',
							my: 0.25,
							px: 1.5,
							py: 0.75,
							borderRadius: 1,
							color: 'text.secondary',
							transition: 'all 0.2s ease-in-out',
							alignItems: 'flex-start',
							textAlign: 'right',
							'&:hover': {
								backgroundColor: 'rgba(25, 118, 210, 0.08)',
								color: 'primary.main',
							},
							'&.Mui-selected': {
								color: 'primary.main',
								fontWeight: 700,
								backgroundColor: 'rgba(25, 118, 210, 0.12)',
							},
						},
						'& .MuiTabs-indicator': {
							display: 'none',
						},
					}}
					value={activeTab}
					onChange={(e, v) => setActiveTab(v)}
					textColor='primary'
					indicatorColor='primary'
				>
					{tabs.map((tab, index) => (
						<Tab key={index} label={tab} />
					))}
				</Tabs>
			</Box>

			{/* Content Area */}
			<Box ref={contentRef} sx={{ flex: 1 }}>
				{tabs.map((tab, index) => (
					<TabPanel key={index} index={index} value={activeTab}>
						<Card
							dir='rtl'
							elevation={2}
							sx={{
								borderRadius: 1.5,
								transition: 'all 0.3s ease-in-out',
								'&:hover': {
									elevation: 4,
								},
							}}
						>
							<CardHeader
								title={
									<Typography variant='h6' component='h2' sx={{ fontWeight: 700, color: 'text.primary', fontSize: '1.1rem' }}>
										{tab}
									</Typography>
								}
								sx={{
									backgroundColor: 'grey.50',
									borderBottom: 1,
									borderColor: 'divider',
									pb: 1,
									pt: 1.5,
									px: 2,
								}}
							/>
							<CardContent sx={{ p: 1.5 }}>
								{index === 0 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
										<Typography variant='h5' sx={{ fontWeight: 700, mb: 0.5 }}>
											ברוכים הבאים ל-GroupHug!
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1 }}>
											בדף המידע, מרוכז לכם כל מה שאתם צריכים לדעת. כאן תמצאו תשובות לכל שאלה, קישורים שימושיים, טיפים והנחיות שיעזרו לכם להוציא את המפגשים שלכם בצורה הכי טובה ומקצועית שיש.
										</Typography>
										
										<Box>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 1, color: 'primary.main' }}>
												מושגים חשובים:
											</Typography>
											<List sx={{ pl: 0 }}>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start' ,textAlign:"right",direction:"rtl"}}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, lineHeight: 1.4 }}>
														צוות המומחים/מומחים
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'  sx={{ lineHeight: 1.4 }}>
														אתם! כל אנשי המקצוע שלוקחים חלק בGroupHug
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-end' ,textAlign:"right",direction:"rtl"}}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600,textAlign:'right' }}>
														״מרחב ייעוץ 1:1״
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														המרחב של המומחים (אנשי מקצוע בתחומים שונים), בו ניתן להעניק שירותי ייעוץ 1:1 למנויים שלנו.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start',textAlign:"right",direction:"rtl" }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														״המרחב הבטוח״
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														מרחב המטפלים, פסיכולוגים ועובדים סוציאלים.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start',textAlign:"right",direction:"rtl" }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														חברות וארגונים
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														כל החברות והארגונים איתם אנחנו עובדים.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start',textAlign:"right",direction:"rtl" }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														המנויים/המשתתפים
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														העובדים בחברות ובארגונים השותפים ל-GroupHug, אשר קיבלו גישה למערכת ויכולים לקבוע פגישות, להצטרף להרצאות ולצפות בתכנים.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start',textAlign:"right",direction:"rtl" }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														הפלטפורמה הדיגיטלית של GroupHug (אתר ואפליקציה)
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														בה מתבצעת קביעת הפגישות, הרשמה להרצאות וגישה לתכנים השונים.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start',textAlign:"right",direction:"rtl" }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														שיחת הכוונה
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														שיחה קצרה בת 20 דקות, שמטרתה לסייע למנוי בתחום ההתמחות שלכם. השיחה אינה שיחת מכירה – מטרתה להעניק ידע מקצועי וערך אמיתי למשתתף.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start' ,textAlign:"right",direction:"rtl"}}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														שיחת Follow-Up
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														שיחה קצרה בת 15 דקות, המתקיימת לאחר שיחת ההכוונה, במטרה להשלים תהליך קצר או לסגור מעגל מקצועי.
													</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, alignItems: 'flex-start' ,textAlign:"right",direction:"rtl"}}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600 }}>
														ייעוץ 1:1
													</Typography>
													{' - '}
													<Typography variant='body1' component='span'>
														פגישת ייעוץ מקצועית במתכונת שאתם קובעים מראש (אורך, נושא ותגמול), בהתאם לתחום ההתמחות שלכם.
													</Typography>
												</ListItem>
											</List>
										</Box>

										<Box>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 1, color: 'primary.main' }}>
												לינקים חשובים
											</Typography>
											<List sx={{ pl: 0 }}>
												<ListItem sx={{ pl: 0, mb: 0.5 }}>
													<Link target="_blank" href='https://experts.grouphug.online/' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
														האזור האישי (כניסה דרך המחשב)
													</Link>
												</ListItem>
												<ListItem sx={{ pl: 0, mb: 1 }}>
													<Link target="_blank" href='https://www.grouphug.online/experts-terms-and-conditions' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
														תנאי שימוש
													</Link>
												</ListItem>
											</List>
										</Box>
									</Box>
								) : index === 1 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											לכל מומחה יש איזור אישי ובו תוכלו לראות כל מה שצריך לדעת על הפעילות שלכם אצלנו:
										</Typography>
										
										<List sx={{ pl: 0, mb: 0.75, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>הפרופיל שלכם</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>[תיאור, תחום מומחיות, פרטי קשר, תעודת הביטוח המקצועית, פרטי חשבון הבנק וכו׳.]</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>זמני הפעילות שלכם אצלנו.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>יומן הפגישות שלכם - מי קבע איתכם ומתי, מה הייתה העלות וכל הפרטים שצריך לדעת לטובת המפגש.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>משובים.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תשלומים פר חודש - עמוד שמתעדכן אוטומטית לפי הפגישות וההרצאות שקיימתם.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>הרצאות וסדנאות - כל ההרצאות והסדנאות שלכם בגאנט ההרצאות שלנו, כמה מנויים נרשמו ומה תוכן ההרצאה.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>עמוד סנכרון היומן האישי שלכם עם היומן של GroupHug.</Typography>
											</ListItem>
										</List>

										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, fontStyle: 'italic', color: 'text.secondary', textAlign: 'right' }}>
											מטה, מתואר תהליך הקמת הפרופיל שלכם, יש לעבור שלב שלב על מנת לוודא שלא פספסתם כלום. באזור הנ״ל, נעבור רק על מה שקריטי להקמת הפרופיל. בהמשך דף המידע, תוכלו לצלול לעומק הפרטים.
										</Typography>

										<Box sx={{ backgroundColor: 'warning.light', p: 1.5, borderRadius: 1, mb: 0.75, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body1' sx={{ fontWeight: 700, color: 'warning.dark', textAlign: 'right' }}>
												שימו לב! רק לאחר שכל הפרטים יושלמו, תקבלו הודעה על הקמת הפרופיל שלכם ועלייתו לאפליקציה.
											</Typography>
										</Box>

										{/* שלב 1 */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												שלב 1: הפעלת האזור האישי שלכם בפעם הראשונה:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												תחילה, יש להיכנס ללינק האזור האישי: <Link href='https://experts.grouphug.online' target='_blank' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>experts.grouphug.online</Link> (מהמחשב)
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												שם המשתמש - המייל שלכם. הסיסמא - זו שהגדרתם במהלך תהליך ההצטרפות.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												לחצו על ״שכחתי סיסמא״ אם שכחתם אותה ואפסו את הסיסמא.
											</Typography>
										</Box>

										{/* שלב 2 */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												שלב 2: היכרות עם האזור האישי:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												באזור האישי שלכם, מופיע כבר כל המידע שמילאתם בתהליך ההצטרפות [התיאור המקצועי שלכם, סוגי השירותים, העלות, חשבון הבנק, מסמכי הביטוח וכו׳]
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												המנויים והמומחים האחרים לא חשופים לאזור האישי שלכם.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.75, fontWeight: 600, textAlign: 'right' }}>
												בואו נכיר באופן ראשוני את כל סוגי הלשוניות ע״פ הסדר (לאחר מכן נעמיק בכל אחת בנפרד):
											</Typography>
											<List sx={{ pl: 0, direction: 'rtl', textAlign: 'right' }}>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״הפרופיל שלי״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>התיאור המקצועי, פרטי הקשר, קישור לעמוד שלכם, מסמכים והפגישות הפרטניות שלכם. מעוניינים לעדכן משהו? זה הזמן (וגם בהמשך, אל דאגה). לאחר כל עדכון - יש ללחוץ בתחתית הדף על ״עדכון״.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״זמני פעילות״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>הזמנים הקבועים במהלך השבוע, אותם אתם מעוניינים לפתוח למנויים שלנו.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״יומן פגישות״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>תיעוד ומעקב אחרי כל הפגישות שלכם, אלה שהיו ואלה שיהיו. מי קבע פגישה, מה סוג הפגישה, כמה שילמו וכו׳. דרך לשונית ״יומן הפגישות״, אתם יכולים לקבוע פגישות שבועיות ופגישות המשך עם המנויים.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״משובים״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>אחרי כל מפגש אישי או הרצאה, המנויים יכולים להשאיר משוב על החוויה שלהם. המשוב כולל דירוג בין 1 ל־5 וכן הערות חופשיות, והוא נשמר באופן פרטי ונגיש לכם (ולנו) בלבד. הדירוגים והמשובים מהווים חלק חשוב בתהליך הלמידה וההתפתחות של כולנו, ואנחנו מקדישים להם תשומת לב רבה – הם מסייעים לנו לשפר את המערכת ולחזק את החוויה של המנויים ושלך כאחד.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״תשלומים״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>כל התשלומים המגיעים לך, כולל הניכויים וכולל הסכום המלא. מחולק לחודשים. על מנת לצפות בנתונים העדכניים ביותר יש ללחוץ על ״עדכון נתונים״.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״הרצאות וסדנאות אונליין״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>מי שלוקח חלק בגאנט ההרצאות - יכול לראות את הרצאות העבר והעתיד, כמות הרשומים והתאריכים.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״סנכרון יומן״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>משמש אותך לחיבור היומן שלך בפעם הראשונה ובהמשך - מוודא שהחיבור ממשיך להתקיים.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
													<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right' }}>״דף המידע״</Typography>
													{' - '}
													<Typography variant='body1' component='span' sx={{ textAlign: 'right' }}>הדף הזה! כל הפרטים שאתה צריך לדעת, נמצאים בדף המידע.</Typography>
												</ListItem>
											</List>
										</Box>

										{/* שלב 3 */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												שלב 3: סנכרון היומן שלכם:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												סנכרון היומן אומר שמערכת הבוקינג שלנו - זו שבאמצעותה נקבעות הפגישות איתכם - מחוברת ליומן המשויך לכתובת המייל שלכם, כפי שמופיעה במערכת.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												המטרה של סנכרון היומן היא לאפשר למערכת לעדכן באופן אוטומטי את היומן האישי שלכם. כך, כל פגישה שנקבעת או מבוטלת במערכת תופיע (או תימחק) ישירות מהיומן שלכם - בלי צורך בעדכון ידני.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												כאשר אתם מוסיפים את שעות הפעילות שלכם (הסבר מפורט בהמשך), אלו יהיו השעות שיוצגו למנויים במערכת לצורך קביעת פגישה.
											</Typography>
											<Box sx={{ backgroundColor: 'info.light', p: 2, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right' }}>
												<Typography variant='body1' sx={{ fontWeight: 600, mb: 1, textAlign: 'right' }}>
													חשוב לדעת
												</Typography>
												<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
													למערכת יש גישה אך ורק לאירועים הקשורים ל-GroupHug. אין לה גישה או אפשרות לראות אירועים פרטיים אחרים ביומן שלכם. המערכת אינה מציגה את כל האירועים שלכם, אלא רק משתמשת במידע על שעות שהתפוסות ביומן כדי לחסום אותן לקביעת פגישות חדשות ומאפשרת הצגה/מחיקה של פגישות שנקבעו דרך המערכת שלנו
												</Typography>
												<Typography variant='body2' sx={{ lineHeight: 1.4, mt: 1, textAlign: 'right' }}>
													לדוגמה: אם הגדרתם שעות פעילות בימי שני (כמו שתעשו בסעיף הבא) בין 09:00 ל-11:00, וביומן שלכם קיים אירוע פרטי (למשל "רופא שיניים") בין 09:00 ל-10:00 - אז רק השעה 10:00-11:00 תופיע במערכת כזמן פנוי ללקוח.
												</Typography>
											</Box>
											<Typography variant='body1' sx={{ fontWeight: 600, mb: 1, textAlign: 'right' }}>
												על מנת לסנכרן את היומן שלכם:
											</Typography>
											<List sx={{ pl: 0, mb: 1, direction: 'rtl', textAlign: 'right' }}>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>היכנסו ללשונית ״סנכרון היומן״ באזור האישי שלכם.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>לחצו על: ״sign in with google״ ולאחר מכן ״Continue״</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>בחרו את חשבון הגוגל אותו תרצו לחבר. ניתן לחבר יומן אחד בלבד, שיציג את הסלוטים הפנויים שלכם במהלך השבוע.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>לאחר הבחירה, תתבקשו להעניק גישה לחשבונכם. המערכת מבקשת גישה רחבה ליומן שלכם כולל כתיבה ומחיקה, משום שזמני הפעילות שלכם בגרופהאג מסונכרנים בתוך היומן שלכם. כמו שכתוב מעלה - לא הלקוח וגם לא אנחנו הצוות יכולים לצפות באירועים שמוגדרים מחוץ למערכת גרופהאג. ללא אישור כלל הסעיפים, לא נוכל להתקדם. בסיום, לחצו על "Continue".</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>חזרו לאזור האישי שלכם.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>אם תהליך הסנכרון הצליח - תוכלו לראות כי כתוב תחת הסמל של Google ״מחובר״.</Typography>
													<Box sx={{ mt: 1, mb: 1, textAlign: 'right' }}>
														<img 
															src='https://cdn.grouphug.online/info-page/diray.png' 
															alt='דוגמה לסנכרון יומן' 
															style={{ maxWidth: '100%', height: 'auto' }}
														/>
													</Box>
												</ListItem>
											</List>
										</Box>

										{/* שלב 4 */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												שלב 4: הוספת שעות פעילות:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												הוספת שעות הפעילות נועד לקבע את הימים והשעות בשבוע שאתם זמינים לקביעת פגישות של מנויי GroupHug.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												כמו שהוסבר מעלה, פעילות ביומן הפרטי שחיברתם, תחסום את הזמינות באותה שעה באופן אוטומטי והמנויים לא יוכלו לקבוע שם.
											</Typography>
											<List sx={{ pl: 0, mb: 1, direction: 'rtl', textAlign: 'right' }}>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>היכנסו לטאב ״זמני פעילות״.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>בלחיצה על הסימן + תוכלו להוסיף שעות פעילות בכל יום וכמו כן לפצל שעות בכל שבוע.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>לדוגמא - תוכלו להגדיר שאתם פנויים ביום ראשון בין 08:00-10:00 ובין 12:00-14:00.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>שימו לב להגדיר את השעות לפי הסדר הכרונולוגי ולהזין קודם את השעה (בצד שמאל) ואת הדקות - בצד ימין.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>
													תוכלו להגדיר שעות פעילות לכל אחד מסוגי המפגשים שלכם בנפרד. תוכלו לקבוע שעות וימים לפגישות מסוג אחד ושעות וימים לפגישות מסוג אחר, אן לשתיהן ביחד. 
לדוגמא: תוכלו לקבוע שאתם מקבלים לפגישת בקליניקה ביום שני בין 08.00-10.00 ובין 10.00-11.00 מקבלים לפגישת אונליין. 


													</Typography>
												</ListItem>
											</List>
                                            <img 
															src='https://cdn.grouphug.online/neww.png' 
															alt='דוגמה לסנכרון יומן' 
															style={{ maxWidth: '100%', height: 'auto' }}
														/>
										</Box>

										{/* שלב 5 */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												שלב 5: חיבור חשבון Zoom/Google meet שלכם:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											החשבונות הללו ישמשו אתכם לטובת עלייה למפגשים הפרטניים שלכם באונליין וכן כלינק שיופיע בלוח ההרצאות במידה ותיקחו בו חלק.
יש להשתמש באחד מהבאים: Zoom PRO או Google Meet PRO.
אנו ממליצים בחום להשתמש בגרסת PRO (בכל אחת מהפלטפורמות) לטובת שמירה על רמה מקצועית גבוהה, יציבות טכנית, ניהול משתתפים תקין וחוויית משתמש מיטבית.
במידה ואין ברשותכם Google Meet PRO, ניתן להשתמש ב-Google Meet בגרסה החינמית; עם זאת, שימוש ב-Zoom יתאפשר אך ורק באמצעות חשבון PRO (לא תתאפשר עבודה עם Zoom חינמי).
											</Typography>
											<Typography variant='body1' sx={{ fontWeight: 600, mb: 1, textAlign: 'right' }}>
												לינק זום:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												אם יש לכם חשבון PRO, (אם לא - ניתן לרכוש חשבון בקישור) יש להכנס לפרופיל הזום האישי שלכם וללחוץ על ״meetings״ ולאחר מכן על "Personal meeting room". העתיקו את הלינק והסיסמא. מומלץ.
											</Typography>
											<Typography variant='body1' sx={{ fontWeight: 600, mb: 1, textAlign: 'right' }}>
												גוגל מיט:
											</Typography>
                                            <img 
															src='https://cdn.grouphug.online/info-page/zoom.png' 
															alt='דוגמה לסנכרון יומן' 
															style={{ maxWidth: '100%', height: 'auto' }}
														/>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												אם אין לכם חשבון זום פרו, ניתן להפיק קישור לגוגל מיט 
                                                {' '}
                                                <Link target="_blank" href='https://meet.google.com/landing' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
                                                בקישור הבא.
													</Link>
                                              
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												לחצו על ״פגישה חדשה״ {'>'} יצירת פגישה למועד מאוחר יותר {'>'} העתיקו את הלינק והדביקו באיזור האישי וגם במקום אחר נגיש ונוח לכם (כדי שתוכלו לגשת ללינק בעתיד, הוא לא נשמר אוטומטית בשום מקום, בניגוד לZoom)
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												על מנת להתאים את ההגדרות, היכנסו ללינק שיצרתם ולחצו על ״אמצעי בקרה למארחים/Host Controls״.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, fontWeight: 600, textAlign: 'right' }}>
												איפה מצרפים את הלינק שלכם?
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												נכנסים לאזור האישי {'>'} ״פרופיל שלי״ {'>'} מילוי פרטי Zoom.
											</Typography>
                                            <img src="https://cdn.grouphug.online/info-page/b.png"></img>
										</Box>

										{/* שלב 6 */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												שלב 6: מעבר סופי על העמוד:
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.75, fontWeight: 600, textAlign: 'right' }}>
												לפני שנעלה את העמוד, יש לעבור על כל הפרטים.
											</Typography>
											<List sx={{ pl: 0, mb: 1, direction: 'rtl', textAlign: 'right' }}>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>לוודא את הפרטים האישיים, התיאור המקצועי שלכם, לוודא שמופיע גם באנגלית וגם בעברית.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>האם אתם עוסק פטור או מורשה.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>קישור הזום שלכם.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>פרטי חשבון הבנק (לא יועברו לאף אחד מלבד הנהלת החשבונות שלנו).</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>תעודת הביטוח שלכם והתוקף שלה.</Typography>
												</ListItem>
												<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Typography variant='body1' sx={{ textAlign: 'right' }}>השירותים הפרטניים שלכם - בדקו את הכותרות, המחירים, התיאורים - בעברית ובאנגלית.</Typography>
												</ListItem>
											</List>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.75, fontWeight: 600, textAlign: 'right' }}>
												סיימתם להגדיר את כל השלבים? מצוין.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												לחצו על הכפתור "סיימתי להגדיר את הפרופיל שלי!".
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												ברגע שתלחצו - המערכת שלנו תקבל התראה אוטומטית. הצוות יעבור על הפרופיל, יוודא שהכל הוגדר כראוי, ואם הכל תקין – תקבלו מייל רשמי שמאשר שאתם חלק מצוות המומחים של GroupHug.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												עם זאת, לפני שמתחילים לעבוד בפועל, חשוב מאוד להמשיך ולעבור על כל דף המידע. בהמשך העמוד תמצאו את כל הפרטים, ההנחיות והפרטים הקטנים שיעזרו לכם להבין איך לעבוד עם המערכת ביום־יום בצורה חלקה ומקצועית.
											</Typography>
										</Box>

										{/* התחברות ראשונה */}
										<Box sx={{ direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
												התחברות ראשונה לאפליקציה
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												על מנת לראות את הפרופיל שלכם, יש להתחבר לאתר/אפליקציה שלנו עם המייל שאליו התחברתם לגרופהאג. בפעם הראשונה שתתחברו, תצטרכו לענות על שאלון. זהו שאלון שכל אחד מהמנויים שלנו מחוייב לענות עליו. אין צורך להשקיע במענה עליו. הוא לא רלוונטי אליכם.
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
												לאחר שתתחברו, תוכלו לחפש את הפרופיל שלכם בעמוד הרלוונטי ולעקוב אחרי גאנט ההרצאות שלנו. אתם יכולים להתחבר דרך הטלפון או דרך המחשב, לבחירתכם.
											</Typography>
											<List sx={{ pl: 0, direction: 'rtl', textAlign: 'right' }}>
												<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Link target="_blank" href='https://apps.apple.com/il/app/grouphug/id6443481916' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
														הורדת האפליקציה ב-APP Store
													</Link>
												</ListItem>
												<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
													<Link target="_blank" href='https://play.google.com/store/apps/details?id=com.grouphug.grouphug&pcampaignid=web_share' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
														הורדת האפליקציה ב-Google Play
													</Link>
												</ListItem>
											</List>

											<Typography variant='body1' sx={{ lineHeight: 1.2, mb: 0.1, textAlign: 'right' }}>
												<b>רשתות חברתיות וLinkedIn:</b>
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.2, mb: 0.1, textAlign: 'right' }}>
כחלק מהעבודה המשותפת שלנו,  נבקש מכם להוסיף בפרופיל האישי שלכם (LinkedIn / אתר / ביו מקצועי) אזכור קצר לכך שאתם עובדים עם GroupHug. האזכור מחזק את הנוכחות המקצועית שלכם מול ארגונים, ממקם אתכם כחלק מנבחרת מומחים הפועלת בזירה הארגונית, ומאפשר לנו לתייג אתכם באירועים ותכנים רלוונטיים וכך להגדיל חשיפה להזדמנויות נוספות.
											</Typography>

										</Box>
									</Box>
								) : index === 2 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='h5' sx={{ fontWeight: 700, mb: 0.5, textAlign: 'right' }}>
											צד המנוי - איך זה עובד?
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											למנויים שלנו יש אפליקציה ייחודית שבה הם יכולים:
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>לתאם ישירות שיחות ייעוץ אישיות עם מומחים ממגוון תחומים לפי הצורך (״מרחב ייעוץ 1:1״) וכן עם מטפלים קליניים (״המרחב הבטוח״).</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>להירשם להרצאות וסדנאות אונליין המתקיימות מדי יום בלייב, ללא עלות נוספת.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>לצפות בתכנים מוקלטים בכל עת/זמן במתחם ה־VOD שלנו, הכולל מאות הרצאות, סרטונים וכלים מעשיים.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>להיחשף לתוכן עדכני, סרטונים קצרים, טיפים יומיומיים ופעילויות עם פרסים והפתעות.</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											איך זה נראה מהצד של המנוי ומה המנויים שלנו מקבלים?
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											כל חברה וארגון בונה ביחד איתנו את התמהיל הנכון עבור העובדים שלה, אבל הזכאות הבסיסית של כל מנוי היא:
										</Typography>

										<Table sx={{ direction: 'rtl', mb: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
											<TableHead>
												<TableRow>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>סוג השירות</TableCell>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>פירוט השירות</TableCell>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>זכאות מנוי</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>המרחב הבטוח</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														מרחב מטפלים אשר בו נמצאים פסיכולוגים ועו"סים, אשר מחזיקים ברישיון טיפול.
														<br />
														ישנן חברות שמסבסדות לעובדים שלהם חלק מטיפולי המרחב הבטוח. לאחר סיום הסבסוד, המנוי יכול להמשיך ולקבוע פגישות - ללא הגבלה, בתשלום מלא.
													</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>ללא הגבלה</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>ייעוץ 1:1</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														המנויים בוחרים מומחה, שירות ושעה פנויה - המערכת מזמנת אוטומטית. אונליין או בקליניקה. התשלום נקבע ע״פ דרישת המומחה.
													</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>ללא הגבלה</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>שיחת הכוונה (20 דק׳)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														עזרה בשאלה או דילמה ממוקדת. לא שיחת מכירה. ללא עלות
													</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														כל מנוי זכאי ל־2 שיחות בחודש עם מומחים שונים (ניתן לפנות לאותו המומחה רק לאחר 3 חודשים מפגישת הייעוץ הראשונה)
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>שיחת Follow-up (15 דק׳)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														סגירת מעגל על שיחת ההכוונה.
													</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														אחת לחודש,
														<br />
														בהמשך לשיחת הייעוץ שקיימו ותוך 30 יום מהפגישה הראשונה.
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>הרצאות וסדנאות</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														השתתפות בלוח ההרצאות החודשי, חשיפה לקהלים רחבים וליווי טכני מלא.
													</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>ללא הגבלה</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>VOD ועוד מלא</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														גישה חופשית למתחם ה- VOD ולמתחמים נוספים הקיימים במנוי.
													</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>ללא הגבלה</TableCell>
												</TableRow>
											</TableBody>
										</Table>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											איך המנויים מזמינים פגישות?
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											באפליקציה, תחת קטגוריית ״ייעוץ 1:1״,יש לנו מגוון של תחומים. לחיצה על כל תחום תוביל לרשימה של מומחים ולחיצה נוספת תוביל לעמוד האישי הכולל בתוכו:
										</Typography>
										<List sx={{ pl: 0, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תיאור מקצועי קצר.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>המלצות מלקוחות.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>פירוט השירותים שניתן להזמין מהמומחה.</Typography>
											</ListItem>
										</List>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											בלחיצה אחת בלבד, המנוי יכול לראות את זמינות המומחה ביומן (חלונות הזמן הפנויים יופיעו בהתבסס על שעות הפעילות שהגדרתם באיזור האישי) לבחור שעה מתאימה, לתאם פגישה (אונליין או פרונטלית) ולשלם -  הכל ישירות מהאפליקציה, בלי צורך בתיווך.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											לאחר הזמנת הפגישה, גם אתם וגם המנוי יקבלו לינק עם כל הפרטים על הפגישה. המנוי, יקבל גם לינק לתשלום ועליו להשלים את התשלום עד 24 שעות מרגע השליחה. אם לא ישלם - הפגישה תתבטל.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											לאחר סיום כל פגישה, המנויים יכולים לתת פידבק על המפגש.
										</Typography>
										<Box sx={{ mt: 1 }}>
											<Link target="_blank" href='https://cdn.grouphug.online/info-page/r.mp4' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' }, fontSize: '1rem' }}>
												לינק לסרטון
											</Link>
										</Box>
									</Box>
								) : index === 3 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											בפרופיל האישי שלכם יופיעו את כל הפרטים שהמנויים רואים וכן את כל הפרטים שאנחנו צריכים לדעת עליכם.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right', fontStyle: 'italic', color: 'text.secondary' }}>
											להעמקה על כל סעיף בפרופיל האישי - יש לקרוא את לשונית ״התחברות בפעם הראשונה״
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.75, textAlign: 'right', fontWeight: 600 }}>
											מטה, נעבור על כל הסעיפים המופיעים בפרופיל האישי:
										</Typography>

										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>קישור לעמוד שלי</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בלחיצה על הקישור, תוכלו לראות את הדף שלכם בתוך האתר/אפליקציה.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>השם שלכם</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בעברית ובאנגלית</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>חייב במע״מ</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>עוסק פטור או מורשה? אל מול הבחירה באופן אוטומטי יתווסף מע״מ.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>יצירת קשר</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מייל אליו ישלחו כל ההתראות על קביעת פגישה.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>טייטל</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בעברית ובאנגלית, הוא זה שיוצג למנויים.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>תיאור</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תיאור מקצועי שלכם, בעברית ובאנגלית. חשוב שיהיה תיאור ברור וקוהרנטי שמסביר בצורה פשוטה מה תחום התמקצעות שלכם ואיזה ערך אתם יכולים לתת למנויים.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>זום</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>קישור לזום/google meet וסיסמא. אם תרצו להחליף בעתיד - תוכלו להחליף כאן. שימו לב - במפגשי ייעוץ 1:1 ובמרחב הבטוח נשלח אוטומטית קישור לפגישה. אם החלפתם קישור לאחר שנקבעה השיחה, יש לשלוח קישור חדש לכל המפגשים העתידיים שלכם.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>פרטי הבנק</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>פרטי חשבון הבנק שלכם לטובת הנהלת החשבונות שלנו. אם תרצו לעדכן חשבון בנק - תוכלו לבצע זאת דרך האיזור האישי ואנחנו נקבל על כך עדכון במייל.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>אישורים ותעודות</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בסעיף זה תופיע תעודת הביטוח המקצועית שלכם (אם נדרש במקצוע שלכם) והתוקף שלה. באחריותכם לוודא שהביטוח בתוקף ולשלוח מסמך מעודכן לקראת סיום התוקף למייל: <Link href='mailto:Experts@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Experts@grouphug.online</Link>.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>שירותים פרטניים</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בסעיף זה יופיעו כל השירותים הפרטניים שלכם, שהמנויים יכולים לקבוע באופן עצמאי. עליכם לשנות כל שירות בנפרד.</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מה תוכלו לשנות בסעיף זה?
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>כותרת השירות (בעברית ואנגלית).</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תיאור השירות (בעברית ובאנגלית)</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>משך השירות, זמן ההפסקה בין מפגש למפגש.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מחיר לפני הנחה ואחרי.</Typography>
											</ListItem>
										</List>

										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											לאחר כל שינוי - יש ללחוץ על ״עדכון״ בסוף הדף.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מה לא ניתן לשנות לבד?
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>שם ומייל.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בשירותים הפרטניים: תמיד תופיע גם שיחת ההכוונה. אותה לא תוכלו לשנות.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>הוספת שירות חדש.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תעודת ביטוח עדכנית.</Typography>
											</ListItem>
										</List>

										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											אם תרצו לבצע שינויים כאלה - נדרש לכתוב מייל עם פירוט השינויים ל-<Link href='mailto:Experts@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Experts@grouphug.online</Link>
										</Typography>
									</Box>
								) : index === 4 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='h5' sx={{ fontWeight: 700, mb: 0.5, textAlign: 'right' }}>
											הגדרת זמני פעילות
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right', fontStyle: 'italic', color: 'text.secondary' }}>
											להגדרת זמני הפעילות בפעם הראשונה -  יש לקרוא את לשונית ״התחברות בפעם הראשונה״.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											הוספה ופיצול שעות פעילות
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>היכנסו לטאב ״זמני פעילות״</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>
													בלחיצה על הסימן + תוכלו להוסיף שעות פעילות בכל יום. לאחר שתוסיפו טווח ראשון, תוכלו ללחוץ שוב על ה +  ולהוסיף טווח שעות נוסף באותו היום.
													</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>לדוגמא - תוכלו להגדיר שאתם פנויים ביום ראשון בין 08:00-10:00 ובין 12:00-14:00.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>
												תוכלו להגדיר שעות פעילות לכל אחד מסוגי המפגשים שלכם בנפרד. תוכלו לקבוע שעות וימים לפגישות מסוג אחד ושעות וימים לפגישות מסוג אחר, אן לשתיהן ביחד. 
													</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>  
												לדוגמא - תוכלו לקבוע שאתם מקבלים לפגישת בקליניקה ביום שני בין 08.00-10.00 ובין 10.00-11.00 מקבלים לפגישת אונליין. 
												</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4, pl: 2 }}>
												שימו לב להגדיר את השעות לפי הסדר הכרונולוגי ולהזין קודם את השעה (בצד שמאל) ואת הדקות - בצד ימין. 

													</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מחיקת שעות פעילות מסוימות
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>היכנסו לטאב ״זמני פעילות״</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מחקו את הטווח הנוכחי, ע״י לחיצה על ה X בטווח השעות.</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											הגדרת חופשה
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>היכנסו לטאב ״זמני פעילות״</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>לחצו בתחתית העמוד על הגדרת חופה והגדירו את טווח הימים שבו אתם בחופש.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בסיום לחצו על ״הגדר״.</Typography>
											</ListItem>
										</List>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											מאותו הרגע, אותם תאריכים יהיו חסומים לזימון מפגשים. שימו לב שבתאריכים שהגדרתם כחופש אין לכם פגישות עם מנויים שצריך לדחות.
										</Typography>
                                        <img src="https://cdn.grouphug.online/info-page/c.png" alt='דוגמה להגדרת חופשה' style={{ maxWidth: '100%', height: 'auto' }} />

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											הגדרת זמני פעילות מול היומן הפרטי
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											אירוע ביומן הגוגל פרטי שחיברתם, יחסום אוטומטית את הזמינות באותה שעה והמנויים לא יוכלו לקבוע שם. כלומר, אם יש לכם מופע אחר ביומן או שמנוי שלנו קבע שם פגישה - אף אחד אחר לא יוכל להזמין את השעה הזו. שימו לב - גם אם האירוע האישי ביומן שלכם יחסום רק דקה משעה שהגדרתם - המנוי לא יוכל להזמין שם פגישה.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											לדוגמא: אם יש לכם ביומן חסימה מ16:00-16:01 - לא תוכל להיקבע פגישה בין 16:00-17:00.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מינימום שעות שעות זמינות במערכת
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											על מנת להופיע באפליקציה ובאתר, חובה להגדיר מספר סלוטים מינימלי בשבוע.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											המערכת שלנו סורקת את השעות הפתוחות שהגדרתם וברגע שאין סלוטים פתוחים בכלל לחודש הקרוב - תקבלו על כך מייל ונוריד אתכם מזמינות באפליקציה.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											אין זה אומר שפגישות שנקבעו כבר יבוטלו - פשוט לא יראו אתכם בחיפוש באפליקציה ולא יוכלו לקבוע פגישות חדשות.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											אם הורדנו אתכם מזמינות - זה לא מספיק רק לפתוח שעות, עליכם לשלוח לנו מייל כדי שנדע לשנות את הסטטוס שלכם במערכת.
										</Typography>
									</Box>
								) : index === 5 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right', fontStyle: 'italic', color: 'text.secondary' }}>
											להעמקה והגדרת זמני הפעילות בפעם הראשונה - יש לקרוא את לשונית ״התחברות בפעם הראשונה״
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											עבודה עם כמה יומנים
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											המערכת שלנו מסונכרנת עם היומן הראשי, שהוא היומן המשויך לכתובת המייל שמופיעה בפרופיל שלכם.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											הסנכרון מאפשר למערכת לבדוק זמינות ותפוסה בזמן אמת, ולקבוע פגישות רק כשהיומן פנוי.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											אם יש לכם כמה יומנים (למשל יומן עבודה נוסף או יומן פרטי), אפשר לוודא שכל האירועים החשובים מופיעים גם ביומן שמסונכרן עם המערכת. ניתן לעשות זאת באמצעות:
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>שיתוף בין יומנים</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>שתפו את היומן הנוסף עם היומן הראשי שלכם, כך שהאירועים יופיעו בו (אפילו רק כ"תפוס").</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>הוספת אירועים ידנית</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>אם יש אירוע ביומן אחר שלא משותף, תוכלו פשוט להוסיף ביומן הראשי אירוע חוסם (למשל "תפוס - ישיבה ביומן אחר").</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											בעיות סנכרון יומן
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											אם נקבעות איתכם פגישות למרות שיש לכם חסימה ביומן הפרטי, בדקו את הבעיות הבאות:
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>בעיית סנכרון בין האפליקציה לאתר</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>לעיתים, אפליקציית גוגל באייפון לא מסונכרת עם גוגל על המחשב וזה גורם לאי התאמות. קודם כל - לחצו על הקישור וודאו שהחסימה אכן נמצאת.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>בעיית סנכרון באנדרואיד</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}><a target='_blank' style={{color: 'blue', textDecoration: 'underline'}}  href='https://support.google.com/calendar/answer/6261951?hl=iw&co=GENIE.Platform%3DAndroid'> לחצו על הקישור.</a></Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>בעיית סנכרון בתוך האזור האישי</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>יש להכנס לעמוד הניהולי, כרטיסיית "סינכרון יומן" ולוודא שמופיע ✅ שמצביע שהסנכרון תקין. אם הסנכרון לא תקין, יש לבצע את תהליך הסנכרון בשנית.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>וודאו שהחסימה ביומן המחובר באזור האישי</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>יש לוודא שהארוע ביומן, הוא ביומן הראשי של חשבון ה-Google שלי (לא יומן "משפחה", "עבודה" וכד'... היומן הראשי, מופיע ראשון ברשימת היומנים)</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>סטטוס ״עסוק״/Busy"</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>וודאו שהסטטוס של הארוע החוסם מוגדר כ"עסוק" / "Busy". אירוע של יום שלם, לא מוגדר בברירת מחדל כ-"עסוק", יש לשנות אותו לכזה (ראו בתמונה מטה)</Typography>
											</ListItem>
										</List>

										<Box sx={{ backgroundColor: 'warning.light', p: 1.5, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right', color: 'warning.dark' }}>
												חשוב!
											</Typography>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												אם נקבעה פגישה בזמן שאינם פנויים/היתה חסימה ביומן ואינם יכולים לקיים את הפגישה מתי שנקבעה, אל תשכחו לבטל אותה/לקבוע מחדש ושלחו מייל למנוי
											</Typography>
                                           
										</Box>
                                        <img src="https://cdn.grouphug.online/info-page/d.png"></img>
									</Box>
								) : index === 6 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											בלשונית הבאה נפרט על כלל המפגשים הפרטניים וההתנהלות שלכם, המומחים, מול המנויים לפני ולאחר קביעת פגישה.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											על מנת לראות למה המנויים זכאים בכל חודש - לחצו על ״צד המנוי״
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											בתחילת התהליך ובפרופיל שלכם - יש את המפגשים הפרטניים שהגדרתם. המנויים רואים את המפגשים האלו באפליקציה ויכולים להזמין עמכם פגישה.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מפגשים פרטניים
										</Typography>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											פגישה נקבעת ע״ המנוי:
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>ברגע שהפגישה (כל סוג פגישה) נקבעת תקבלו מייל, זימון ליומן והודעת WhatsApp.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בזימון שנשלח למנוי ואליכם מופיע לינק לזום אשר עליו יתקיים המפגש - זהו אותו הלינק שהזנתם כלינק קבוע בפרופיל שלכם. וודאו שהלינק שמופיע בזימון והוא אכן הלינק הנכון.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מייל תזכורת אוטומטי יישלח ללקוח כרבע שעה לפני תחילת הפגישה כמו גם הודעת וואטסאפ אליו וגם אליכם.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מיד לאחר הפגישה, יש ליצור קשר עם המנוי שקבע מהר כלל הניתן: שלחו לו מייל או WhatsApp, הציגו את עצמכם, בקשו לדעת במה ירצה להתמקד בפגישה (ככותרת כללית) על מנת להגיע מוכנים יותר.</Typography>
											</ListItem>
										</List>
										<Box sx={{ backgroundColor: 'info.light', p: 1.5, borderRadius: 1, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
												דוגמה למייל /הודעה שאפשר לשלוח:
											</Typography>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right', fontStyle: 'italic' }}>
												הי __________<br />
												קיבלתי את הזימון לפגישה שלנו ביום _____ בשעה _______.<br />
												נקיים את המפגש על הלינק המצורף: _________________________ (כאן יייכנס אותו הלינק הקבוע המופיע בפרופיל שלכם)//הפגישה תתקיים בקליניקה בכתובת____ (+הוראות הגעה).<br />
												<br />
												אשמח אם תוכל לכתוב לי בכמה מילים על מה היית רוצה להתייעץ בכדי שאוכל להגיע ממוקד יותר לזמן העומד לרשותנו.<br />
												תודה!
											</Typography>
										</Box>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											הפגישה תופיע לכם באזור האישי שלכם, תחת לשונית ״יומן פגישות״. תוכלו לראות ע״י מי היא נקבעה, מתי, איזה סוג פגישה זאת ומה עלות הפגישה. פגישות עתידיות יופיעו בצבע ירוק.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											קביעת פגישה חוזרת עם מנוי
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											תחת לשונית "יומן פגישות"- ישנה אפשרות לקביעת מפגש נוסף על ידכם (כמובן שגם המנוי יכול לקבוע בעצמו, ואפילו עדיף). עליכם למצוא את הפגישה האחרונה עם המנוי ובלחיצה על האייקון של ״לוח השנה והחץ המעוגל״ תיפתח תיבה ובה האפשרות ל"קביעת מפגש נוסף" בה תוכלו להזין את משך הפגישה והמועד בה תרצו שתתקיים.
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>אם הפגישה היא פגישה ללא תשלום היא תיכנס באופן מיידי ליומן שלכן ושל הלקוח.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>אם הפגישה היא פגישה בתשלום, אוטומטית תשלח ללקוח דרישה לתשלום. הסלוט הנבחר יהיה שמור ללקוח ל-5 שעות מרגע קביעת הפגישה על ידכם.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>באם לא התקבל תשלום עבור הפגישה - הפגישה תימחק והסלוט יתפנה לקביעה מחדש.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>עד הרגע שבו הלקוח ישלם, תוכלו לראות את סטטוס הפגישה כ- "טרם אושר".</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											ביטול פגישה
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											המנוי יכול לתאם את הפגישה במערכת וגם לבטל אותה בקלות באותה הדרך.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											באפשרות המנוי לבטל פגישה עד 12 שעות לפני קיומה העתידי ולקבל זיכוי על הפגישה. לאחר 12 שעות - יש לפנות לשירות הלקוחות שלנו על מנת לקבל זיכוי או על מנת לתאם את הפגישה בזמן אחר (אם מקובל עליכם), על אף שלא עמד בתנאי הביטול.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											גם אתם דרך טאב "יומן פגישות" יכולים לבטל פגישה אם היא לא פגישה בתשלום. גם דרך האיזור האישי יתאפשר ביטול עד 12 שעות לפני הפגישה, במידה וברצונכם לבטל פגישה מחוץ לחלון הזמן הזה יש לפנות לתמיכת המומחים שלנו.
										</Typography>
										<Box sx={{ backgroundColor: 'warning.light', p: 1.5, borderRadius: 1, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												חשוב לדעת - ביטול הפגישה דרך יומן הגוגל, שלכם או של המטופל (כלומר אתם תראו דחייה לזימון) - אין זה אומר שהפגישה בוטלה והכסף הוחזר. ביטול פגישה מתבצע אך ורק דרך המערכת/האפליקציה של גרופהאג. אם יש ספק, אין ספק - שלחו למנוי הודעה.
											</Typography>
										</Box>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מנויים שלא עלו לפגישה (הכוונה, Followup)
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											במקרה שכזה, יש לעדכן אותנו במייל (
											<Link href='mailto:experts@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
												experts@grouphug.online
											</Link>
											) ולצרף את שם וכתובת האימייל של המנוי שלא הגיע לפגישה. מכיוון שפיניתם מזמנכם, הפגישה תיחשב כאילו התרחשה.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											עדכון מועד פגישה
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											יכול להתבצע על ידכם, דרך האיזור האישי, או על ידי המנוי. עליו להיכנס לפגישה הקיימת באפליקציה ולערוך את היום והשעה, כל עוד זה בטווח של עד 12 שעות לפני הפגישה המיועדת.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											שירות שמוגדר כתהליך [רכישת מספר מפגשים]
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											אם אחד מהשירותים שלכם, הוא שירות שהוא ״תהליך״ (מספר מפגשים), יש לתמחר אותו בתמחור המלא שתרצו עליו, אבל אורך הפגישה - צריך להיות אורך הפגישה הראשונה בתהליך.
										</Typography>
										<Box sx={{ backgroundColor: 'info.light', p: 1.5, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												לדוגמא: שירות ייעוץ הכולל בתוכו 4 מפגשים. עלות השירות: 2000 ש״ח (500 ש״ח לפגישה). אורך הפגישה: 60 ד׳ (ולא 240)
											</Typography>
										</Box>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											אין אצלנו היום אופציה עדיין להזמין ״תהליך״. המנוי יצטרך לשלם את התשלום המלא כפי שתומחר על ידכם במעמד קביעת הפגישה הראשונה. הפגישה הראשונה שלכם תיקבע דרך גרופהאג, אבל את שאר הפגישות בתהליך - תצטרכו לתאם לבד.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											פגישות טיפול מחוץ למערכת
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											ברגע שפגישה נקבעת מחוץ למערכת, למעט אירועים חריגים שאנחנו מודעים אליהם - אין לנו דרך לעקוב אחריה ולא נדע שהיא התקיימה. באחריותכם לוודא שהפגישה שולמה ותואמה כראוי. במקרים המיוחדים, יש לשלוח מייל למייל תמיכת המומחים ולעדכן על הפגישות שנקבעו מחוץ למערכת.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											משובים
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											לאחר כל פגישה, המנוי יקבל קישור למילוי משוב. תוכלו לראות את המשובים האלו בלשונית ״משובים״ באזור האישי. אנחנו מייחסים למשובים האלה חשיבות רבה. כיום, המשובים האלה אינם חשופים לשאר המנויים.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											אירועים מיוחדים
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											במסגרת השירותים שלנו, מגיעות אלינו מידי פעם בקשות מיוחדות המצריכות ייחס ייחודי, דרך איש הקשר בחברה (לרוב, מנהלות הHR). לדוגמא - עובד שנמצא במצוקה/אירוע מיוחד שקרה בחברה וכו׳.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											לרוב, נעביר את הפניה בקבוצה ונבקש שאנשי המקצוע הרלוונטים יפנו אלינו ולעיתים, נעביר לידים ופניות באופן ישיר. לידים ופניות אלה הם לקוחות הפונים לסיוע/עצה ומהווים פוטנציאל אמיתי ומוכח להמרת הפנייה ללקוח משלם.
										</Typography>
										<Box sx={{ backgroundColor: 'warning.light', p: 1.5, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												עם העברת פרטי הפניה מגרופהאג, עליכם ליצור קשר עם המנוי מהר ככל האפשר ולא יאוחר משלוש שעות מזמן העברת הפנייה. במידה ואינכם פנויים לטפל בפנייה, עליכם לעדכן את גרופהאג כדי שהפרטים של הפניה יעברו ליועצת אחרת.
											</Typography>
										</Box>
									</Box>
								) : index === 7 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='h5' sx={{ fontWeight: 700, mb: 0.5, textAlign: 'right' }}>
											הרצאות וסדנאות בלוח החודשי
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											כחלק מהשירותים שהמנויים שלנו מקבלים, יש לנו גאנט תוכן מגוון ומעשיר. בכל חודש יש בגאנט כ-30 הרצאות ואימוני כושר במתכונת מפגשי אונליין ולייב, בוקר וערב. לקראת כל הרצאה יש טסט והכנה עם הצוות הטכני שלנו וכן ליווי מלא לאורך ההרצאה עצמה.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											מטרת ההרצאות היא להעביר ידע פרקטי ומדויק אך גם לתת מקום לשאלות והתייחסויות אישיות של המשתתפים ולכן, נדרש להיערך עקרונית להרצאה/סדנה אינטראקטיבית ולא להרצאה שבה מועבר התוכן באופן חד צדדי.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											החשיפה היא לקהל יעד רחב ומגוון ולכן ההשתתפות שלכם מהווה פלטפורמת חשיפה משמעותית שתורמת באופן ישיר לכמות הלידים החדשים שתקבלו מהמנויים.
										</Typography>
										<Box sx={{ backgroundColor: 'warning.light', p: 1.5, borderRadius: 1, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												חשוב לנו מאוד להדגיש - אלו לא שיחות מכירה. אנחנו רגישים לפידבקים שאנחנו מקבלים מההרצאות ואם נרגיש ההרצאה לא תאמה את תיאום הציפיות המקדים - לא נתאם הרצאות נוספות בהמשך עם אותו המומחה.
											</Typography>
										</Box>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											גאנט ההרצאות נבנה ע״פ הצרכים והעניין שעולה מהמנויים ונלקחים בחשבון המשובים שלכם והוא נבנה בין חודשיים לשלושה קדימה. אנחנו ניצור עמכם קשר לראות מתי נכון לשבץ את ההרצאה מבחינת תמהיל התוכן שלנו לכל חודש. אורך כל הרצאה הוא כשעה. 45 ד׳ של תוכן מקצועי בליווי מצגת + 15 ד׳ לפחות, לזמן שאלות ותשובות בסיום.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											הצעות לסדנאות והרצאות לא נקבעות דרך האיזור האישי שלכם ואם ברצונכם לקחת חלק יש למלא את הטופס הבא.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											הפורמט הנדרש במהלך ההרצאה
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											על מנת לספק את החוויה הנכונה למשתתפים - יש להיערך עם תוכן שאורכו כשעה הכולל:
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>45 דקות - תוכן מקצועי בליווי מצגת.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>15 דקות - זמן לשאלות ותשובות בסיום.</Typography>
											</ListItem>
										</List>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											לפני הרצאה, יארך טסט שיקבע ביחד עם הצוות הטכני שלנו (גג עד יום לפני ההרצאה). הטסט הוא חובה. הצוות ילווה אתכם גם במהלך ההרצאה עצמה.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											ההרצאות מתקיימות על בסיס לינק הזום/גוגל מיטס שהגדרתם בפרופיל שלכם.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											לפני ההרצאה לקראת הטסט הטכני יש להיערך לפי הדגשים הבאים
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>מצגת מותאמת:</Typography>
												<List sx={{ pl: 2, mt: 0.5, direction: 'rtl', textAlign: 'right' }}>
													<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
														<Typography variant='body2' sx={{ textAlign: 'right', lineHeight: 1.4 }}>יש לפתוח את הקישור שלכם 10 דקות לפני תחילתה של ההרצאה יחד עם שקופית פתיחה שתוצג על המסך, בליווי מוזיקת רקע נעימה <a href="https://www.youtube.com/watch?v=wTClRrOd0G0&list=PLND-wc-WOkCFILPsgcQBkCBacEymC-f9w" style={{color: 'blue', textDecoration: 'underline'}}  target="_blank">(מצורף קישור) </a></Typography>
													</ListItem>
													<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
														<Typography variant='body2' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בשקופית הפתיחה יופיעו שם ההרצאה + שם המרצה   <a href="https://www.canva.com/design/DAGF7rwIoXU/qRKyss62l-mxRIvq2hAtLQ/edit" style={{color: 'blue', textDecoration: 'underline'}}  target="_blank">(קישור לטמפלייט שקופית הפתיחה) </a></Typography>
													</ListItem>
													<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
														<Typography variant='body2' sx={{ textAlign: 'right', lineHeight: 1.4 }}>יש לעבור על טמפלייט המצגת וזרימה של ההצגה שלה (כולל שיתוף המסך עם/בלי סאונד)</Typography>
													</ListItem>
													<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
														<Typography variant='body2' sx={{ textAlign: 'right', lineHeight: 1.4 }}>זמן ההצגה העצמית שלכם לא עולה על דקה. אנחנו מזכירים - זוהי לא פגישת מכירה.</Typography>
													</ListItem>
												</List>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ fontWeight: 600, textAlign: 'right', lineHeight: 1.4 }}>לינק ההרצאה (זום/גוגל meet) -</Typography>
												<List sx={{ pl: 2, mt: 0.5, direction: 'rtl', textAlign: 'right' }}>
													<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
														<Typography variant='body2' sx={{ textAlign: 'right', lineHeight: 1.4 }}>וידוא תקינות הקישור</Typography>
													</ListItem>
													<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
														<Typography variant='body2' sx={{ textAlign: 'right', lineHeight: 1.4 }}>וידוא כי שהגדרות הלינק מחייבות כניסה על MUTE.</Typography>
													</ListItem>
												</List>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>בדיקת יציבות האינטרנט - מיקום מחשב ביחס לראוטר (אם צריך חיבור בכבל ולא WI-FI)</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מצלמה - לוודא שמצלמת המחשב מצלמת באיכות טובה</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>סאונד- לוודא שהסאונד דרך המחשב תקין</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תאורה - רצוי להשתמש ברינג או במנורה שימוקמו לפניכם</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מיקום וגובה המחשב - יש לכוון את המחשב לגובה העיניים</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מיקום בחלל- יש לוודא שהרקע נקי מאחוריכם.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>הפרעות ברקע - כבישים/כלבים/שכנים - יש לוודא כי הסביבה שקטה ללא הפרעות.</Typography>
											</ListItem>
										</List>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											מצלמות פתוחות - אין חובת פתיחת מצלמות. אם תרצו שהמשתתפים יפתחו מצלמות במהלך ההרצאה, אפשר להוסיף לכך משפט בשקף הפתיחה. בנוסף, ניתן להציע תמריץ קטן: למשל, "מי שפותח מצלמה יקבל ממני לאחר ההרצאה חומר בונוס במייל – שלושה טיפים נוספים בלעדיים." אחריות על איסוף כתובות האימייל ושליחת החומר היא שלכם.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											יש אפשרות להעביר לנרשמים שאלון/טקסט/משימה או כל דבר שתרצו כדי לחבר אותו ולייצר אצלו יותר מחויבות להשתתפות. העבירו אלינו את מה שתרצו לשלוח ושירות הלקוחות יעביר לנרשמים את ששלחתם.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											במהלך ההרצאה
										</Typography>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											הקלטת הרצאות
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											כל ההרצאות, למעט מקרים מיוחדים, מוקלטות ומועלות לVOD שלנו, בכדי לאפשר חשיפה נוספת. יש להקליט את ההרצאה, כך שלא רואים את המשתתפים, אלא רק את המצגת ולהעביר אותה אלינו למייל{' '}
											<Link href='mailto:experts@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
												experts@grouphug.online
											</Link>
											{' '}לא יאוחר מיום לאחר קיום ההרצאה. גרופהאג שומרת לעצמה את ההחלטה אילו הקלטות יעלו ואילו לא. ההקלטות יושבות תחת ספריית VOD בנושא הרלוונטי וזמינות לצפייה כל הזמן.
										</Typography>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											ממשק עם נרשמים ומשתתפים
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											יובהר כי בהתאם לחוק הספאם ותחת נהלי חברת גרופהאג, אין ליצור קשר ישירות עם הנרשמים ו/או המשתתפים בכל צורה שהיא, לפני ההרצאה או לאחריה, למעט אם אלה ביקשו זאת באופן מפורש ובכתב. אנחנו ממליצים לשלוח בצ'אט לינק לעמוד הנחיתה שלכן בגרופאג/ עמוד האינסטגרם שלכן/הפייסבוק.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											דגשים נוספים
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											בלשונית ״הרצאות וסדנאות״, תוכלו לראות את ההרצאות הקודמות והעתידיות שהעברתם, את התאריך, הנושא וכמות הנרשמים. נרשם יכול לבטל את הרישום שלו בכל רגע ומכאן יכול לנבוע שינוי במספר הנרשמים.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											פרסום ההרצאות
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											בכל תחילת חודש יוצא ניוזלטר מטעם גרופהאג לכל המנויים ובו מפורטות ההרצאות שלנו החודש. בכל תחילת שבוע, יוצא ניוזלטר נוסף ובו מפורטות הרצאות השבוע.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											כשבועיים לפני תחילת גאנט ההרצאות, תקבלו מייל ובו קישורים ללוח ההרצאות. אתם יותר ממוזמנים לפרסם את ההרצאה אצלכם ברשתות החברתיות (ואנחנו כמובן נשתף אותה גם אצלנו בעמוד)
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											הרצאה יכולה לחזור מספר פעמים בלוח ההרצאות במהלך השנה, גם אם כבר התקיימה וגם אם הועלתה לVOD.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											הנרשמים מקבלים אוטומטית לינק למשוב בסיום ההרצאה. משובים אלה מופיעים בפרופיל האישי.
										</Typography>
										<Box sx={{ backgroundColor: 'warning.light', p: 1.5, borderRadius: 1, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												במידה ותואמה מולכם הרצאה - אין אפשרות לבטלה, ועל כן בדקו שלוח הזמנים שלכם אכן פנוי לטובת העניין. חשוב להבין כי לאחר קביעת תאריך ההרצאה, היא עולה לאוויר וההרשמות אליה פתוחות. כל שינוי, בתאריך או בשעה, אי נוחות מול המנויים וחשוב לנו להימנע מכך.
											</Typography>
										</Box>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											פירוט על התשלום תוכלו למצוא בעמוד התשלומים.
										</Typography>

										<Typography variant='h5' sx={{ fontWeight: 700, mb: 0.75, textAlign: 'right', mt: 1 }}>
											הרצאות חוץ - גרופהאג
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											כחלק מהשירותים שלנו, מגיעות אלינו פניות מארגונים איתם אנחנו עובדים, להרצאות פרונטליות/בזום - ייעודית לאותו הארגון. לרוב, הארגון מבקש הרצאות בתחום מסויים. אם התחום רלוונטי אליכם, ייתכן ונפנה אליכם לטובת הצעת מחיר להרצאה שכזו. ההרצאות הללו מתומחרות באופן שונה ונקבעות ע״פ דרישתכם.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											אנחנו מעבירים רשימת הרצאות לארגון הפונה. אם ההרצאה שלכם תהיה רלוונטית - נפנה אליכם לתיאום ועם כל הפרטים הנדרשים.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											בניגוד להרצאות בגאנט ההרצאות, גרופהאג גובה עמלה על החיבור בין החברה לבינכם.
										</Typography>
									</Box>
								) : index === 8 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right' }}>
											סיכום פעילות ותיעוד
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											כל הפעילות שלכם דרך GroupHug תופיע באזור האישי שלכם תחת לשונית ״יומן פגישות״ - הפגישות, העלות, התאריכים והשעות.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											בלשונית ״תשלומים" יוצג סיכום חודשי של כלל השירותים שהענקתם – כולל הרצאות בלוח החודשי ומפגשים פרטניים. על מנת לראות את הנתונים העדכניים ביותר, יש ללחוץ על ״עדכון נתונים״.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											מועדי ותנאי התשלום
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											התשלום בGroupHug מתבצע בהעברה בנקאית ובתנאי תשלום של שוטף +30.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											התשלום החודשי יועבר ב-1 לכל חודש, עבור הפעילות של החודש הקודם.
										</Typography>
										<Box sx={{ backgroundColor: 'info.light', p: 1.5, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												לדוגמה: התשלום עבור חודש דצמבר יועבר ב-1 בפברואר.
											</Typography>
										</Box>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											עם קבלת התשלום, ועד ל-5 ימים לאחר העברתו, יש להוציא חשבונית מס-קבלה או קבלה על הסכום שהתקבל ולשלוח אותה להנהלת החשבונות שלנו -{' '}
											<Link href='mailto:Office@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
												Office@grouphug.online
											</Link>
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											פרטי החברה לצורך הנה"ח: גרופהאג אונליין בע״מ ח.פ. 516312865.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											כדי להימנע מפערים בתשלום בסוף החודש - יהיה עליכם לקבוע את כל המפגשים עם המנויים דרך מערכת האיזור האישי/האפליקציה. מפגשים מחוץ למערכת/שלא שולמו לא יופיעו ולא נדע לשלם עבורם.
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											עדכון חשבון בנק - באזור האישי שלכם, בלשונית הפרופיל האישי, תוכלו למלא את חשבון הבנק שלכם ולשנות אותו לטובת התשלומים.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											איך בנוי מערך התשלומים?
										</Typography>
										<Table sx={{ direction: 'rtl', mb: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
											<TableHead>
												<TableRow>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>סוג השירות</TableCell>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>מה המנוי משלם</TableCell>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>תשלום למומחה</TableCell>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>ניכויים ותוספות</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>ייעוץ 1:1 (אורך השירות נקבע לפי בחירתכם)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>את המחיר שקבעתם עבור אותו שירות</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>את המחיר המלא אותו ביקשתם עבור אותו השירות.</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>
														ניכוי 3% ממחיר השירות עבור עמלת סליקה.
														<br />
														לעוסק מורשה - המע״מ נכלל בתוך המחיר של השירות. כלומר, אם הזנת 250 ש״ח, זה יהיה התשלום, כולל מע״מ.
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>שיחת הכוונה (20 דק׳)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>חינם, עד שתי פגישות בחודש</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>70 ש״ח החל מהפגישה השנייה בחודש (לא פר מנוי)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>לעוסק מורשה - מחויב בתוספת מע״מ עבור כל פגישת הכוונה בתשלום</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>שיחת Follow-up (15 דק׳)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>חינם, עד פגישה אחת לחודש למנוי</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>70 ש״ח החל מהפגישה השנייה בחודש (כולל שיחות ההכוונה)</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>לעוסק מורשה - מחויב בתוספת מע״מ עבור כל פגישת הכוונה בתשלום</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, textAlign: 'right', verticalAlign: 'top' }}>הרצאות וסדנאות</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>חינם, ללא הגבלה</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>**התשלום עבור ההרצאות והסדנאות נקבע ע״פ כמות הנרשמים.</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>לעוסק מורשה - תוספת מע״מ עבור כל הרצאה</TableCell>
												</TableRow>
											</TableBody>
										</Table>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											תשלומי הרצאות - תשלום ע״פ כמות נרשמים להרצאות
										</Typography>
										<Table sx={{ direction: 'rtl', mb: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
											<TableHead>
												<TableRow>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>מספר נרשמים</TableCell>
													<TableCell sx={{ fontWeight: 700, textAlign: 'right', borderBottom: '2px solid', borderColor: 'divider' }}>תשלום למרצה (לא כולל מע״מ)</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>5-15</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>350 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>16-25</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>500 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>26-40</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>550 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>41-60</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>650 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>61-80</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>800 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>81-100</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>950 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>100-120</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>1,100 ₪</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>121-140</TableCell>
													<TableCell sx={{ textAlign: 'right', lineHeight: 1.4 }}>1,200 ₪</TableCell>
												</TableRow>
											</TableBody>
										</Table>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											פחות מ-5 נרשמים – ההרצאה תבוטל, כ-48 שעות לפני הזמן המיועד. מעל 140 נרשמים – המחיר יתואם מול המרצה באופן פרטני.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											עוסק פטור
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											חישוב התשלומים המלא, עבור כל השירותים של אותו החודש, יכלול הורדה של 18% אותם אנו גובים (גרופהאג כחברה בע"מ משלמת מע"מ עבור הפגישות שלכם גם אם הינכם עוסק פטור ולכן נגבה מכם סכום זה).
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											הנחת GroupHug
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1.5, textAlign: 'right' }}>
											אנחנו מאמינים בשיתופי פעולה שמיטיבים עם כולם - גם עם המטפלים וגם עם הקהילה שלנו ולכן כחלק מההצטרפות, אנחנו מבקשים מכם להציע את השירותים שלכם בהנחה בלעדית למנויי GroupHug.
										</Typography>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											קוד קופון
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											באפשרותכם להעניק ״קוד קופון״ למנויים הקבועים שלכם, שיעניק הנחה סכומית לעלות המפגש.
										</Typography>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											איך עושים את זה?
										</Typography>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											מהצד שלכם:
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 0.5, textAlign: 'right' }}>
											שולחים לתמיכת המומחים מייל עם הפרטים הבאים:
										</Typography>
										<List sx={{ pl: 0, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>שם קוד הקופון - למשל GROUPHUG12 (אותיות אנגלית גדולות+ מספר)</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>סוג ההנחה: בש״ח או באחוזים</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>על אילו שירותים יפעל הקוד קופון- האם רק על שירותים למנוי או גם לשירותים באתר הציבורי ללקוחות בתשלום. חשוב לציין את שם השירות כפי שהוא מופיע בפרופיל שלכם.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תוקף קוד הקופון- תאריך סיום או פרק זמן.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>הגבלת שימוש: למשל ניתן להגדיר הגבלה של 5 שימושים בקוד הקופון עבור הלקוח\ות שבחרתם לשלוח לו\להם את קוד הקופון.</Typography>
											</ListItem>
										</List>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											מצד הלקוח:
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											ברגע שקוד הקופון הוגדר, עליכם להעביר אותו למנויים הרלוונטים. על מנת לממש אותו, הם צריכים להזין אותו בעת הזמנת המפגש.
										</Typography>
										<Typography variant='body1' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
											הזנת קוד קופון בזימון פגישה דרך הפרופיל האישי - במידה ואתם מזמנים את הפגישות דרככם:
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>באזור האישי, לחצו על לשונית ״יומן פגישות" {'->'} מציאת הפגישה האחרונה של המנוי {'->'} ״פגישה נוספת״ {'->'} הזינו את משך המפגש, המועד וכן את קוד הקופון המתאים.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Typography variant='body1' sx={{ textAlign: 'right', lineHeight: 1.4 }}>נקבע את זמן הפגישה, מועד הפגישה, וקוד קופון במידה וקיים, לאחר מכן נלחץ על קביעת פגישה.</Typography>
											</ListItem>
										</List>

										<Box sx={{ backgroundColor: 'info.light', p: 1.5, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body2' sx={{ fontWeight: 600, mb: 0.5, textAlign: 'right' }}>
												קישורים חשובים
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.2, mb: 0.1, textAlign: 'right' }}>
											בכל שאלה הנוגעת לבירור על תשלומים/פערים/שאלות וכו׳ - כתבו למייל תמיכת המומחים -<a  href='mailto:Experts@grouphug.online' target='_blank' style={{color: 'blue', textDecoration: 'uderline' }}>  Experts@grouphug.online </a>
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.2, mb: 0.5, textAlign: 'right' }}>
                                        חשבוניות לאחר התשלום יש לשלוח להנהלת החשבונות שלנו - <a href='mailto:office@grouphug.online' target='_blank' style={{color: 'blue', textDecoration: 'undeline' }}>office@grouphug.online</a>
										</Typography>
										</Box>
									</Box>
								) : index === 9 ? (
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, direction: 'rtl', textAlign: 'right' }}>
										<Box sx={{ backgroundColor: 'info.light', p: 1.5, borderRadius: 1, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right', fontWeight: 600, mb: 0.5 }}>
												לפני שאתם יוצרים קשר
											</Typography>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right' }}>
												אנחנו מבטיחים - כל התשובות לשאלות נמצאות בדף הנ״ל. עשו עוד מעבר קטן לפני שאתם כותבים לנו.
											</Typography>
											<Typography variant='body2' sx={{ lineHeight: 1.4, textAlign: 'right', mt: 0.5 }}>
												בנוסף, אנא הקפידו לשלוח את הפנייה שלכם למייל הנכון. אם הוא לא יגיע למקום הנכון - לא נדע לטפל
											</Typography>
										</Box>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											כתובות מייל
										</Typography>
										<Typography variant='body1' sx={{ lineHeight: 1.4, mb: 1, textAlign: 'right' }}>
											נא הקפידו לשלוח את
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Link href='mailto:experts@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
													experts@grouphug.online
												</Link>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מייל תמיכת המומחים. המייל העיקרי שלכם! כל פנייה בכל שאלה הקשורה להתנהלות עם המערכת, מנויים, דילמות, שאלות, תשלומים עתידיים, תשלומי עבר וכו׳ - שלחו אליו.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Link href='mailto:contact@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
													contact@grouphug.online
												</Link>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>שירות הלקוחות שלנו, הפנו את המנויים אליו אם יש להם שאלות.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Link href='mailto:office@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
													office@grouphug.online
												</Link>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>מייל הנהלת החשבונות שלנו. למייל הנ״ל שלחו רק את החשבוניות ודרישות תשלום. אם יש שאלה על תשלום - שלחו למייל תמיכת המומחים.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Link href='mailto:gaya@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
													gaya@grouphug.online
												</Link>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>גאיה, מנהלת תוכן ומומחים - רק לפניות דחופות.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>
													<Link href='mailto:Shoam.g@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
														Shoam.g@grouphug.online
													</Link>
													{' or '}
													<Link href='mailto:shirel@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
														shirel@grouphug.online
													</Link>
												</Typography>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>תמיכה טכנית להרצאות וסדנאות.</Typography>
											</ListItem>
											<ListItem sx={{ display: 'block', pl: 0, mb: 0.75, textAlign: 'right' }}>
												<Link href='mailto:dolev.b@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
													dolev.b@grouphug.online
												</Link>
												{' - '}
												<Typography variant='body1' component='span' sx={{ textAlign: 'right', lineHeight: 1.4 }}>דולב, מנהלת לקוחות עסקיים.</Typography>
											</ListItem>
										</List>

										<Typography variant='h6' sx={{ fontWeight: 700, mb: 0.75, color: 'primary.main', textAlign: 'right', mt: 1 }}>
											לינקים חשובים
										</Typography>
										<List sx={{ pl: 0, mb: 1.5, direction: 'rtl', textAlign: 'right' }}>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://experts.grouphug.online/' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													האזור האישי (כניסה דרך המחשב)
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://web.grouphug.online/home/' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													דף הבית
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://web.grouphug.online/member-group-sessions' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													לוח הרצאות באתר
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://web.grouphug.online/one-to-one' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													עמוד המומחים באתר
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://web.grouphug.online/one-to-one/safe-space' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													עמוד המטפלים באתר
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://www.grouphug.online/experts-terms-and-conditions' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													תנאי שימוש
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='#' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													מילוי פרטים להרצאה/סדנה בלוח החודשי
												</Link>
											</ListItem>

											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://docs.google.com/forms/d/e/1FAIpQLSeDaz3mx5nv0dxXiQ8VlMfSForq1nloIU8kiDMfQ62ndoAT4Q/viewform' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
												מילוי פרטים להשתתפות ב״הכר את המומחה״
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													מסלולי הצטרפות לאנשי מקצוע
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://apps.apple.com/il/app/grouphug/id6443481916' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													הורדת האפליקציה ב-APP Store
												</Link>
											</ListItem>
											<ListItem sx={{ pl: 0, mb: 0.5, textAlign: 'right' }}>
												<Link target="_blank" href='https://play.google.com/store/apps/details?id=com.grouphug.grouphug&pcampaignid=web_share' sx={{ textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}>
													הורדת האפליקציה ב-Google Play
												</Link>
											</ListItem>
										</List>

										<Box sx={{ backgroundColor: 'info.light', p: 1.5, borderRadius: 1, mb: 1, direction: 'rtl', textAlign: 'right', mt: 1 }}>
											<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right', mb: 0.5 }}>
												לא מצאתם מה שחיפשתם? אנא כתבו לנו במייל{' '}
												<Link href='mailto:Experts@grouphug.online' sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
													Experts@grouphug.online
												</Link>
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right', fontStyle: 'italic' }}>
												לכל דבר נוסף, אנחנו כאן, ונשמח לעזור 😊
											</Typography>
											<Typography variant='body1' sx={{ lineHeight: 1.4, textAlign: 'right', fontWeight: 600, mt: 0.5 }}>
												צוות GroupHug
											</Typography>
										</Box>
									</Box>
								) : (
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											minHeight: 150,
											py: 3,
										}}
									>
										<Typography
											variant='body2'
											sx={{
												color: 'text.secondary',
												fontSize: '0.95rem',
												fontStyle: 'italic',
											}}
										>
											תוכן יועלה בקרוב
										</Typography>
									</Box>
								)}
							</CardContent>
						</Card>
					</TabPanel>
				))}
			</Box>
		</Box>
	);
};

export default InfoPage;

